import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';
import 'highlight.js/styles/github-dark.css';

// Stable references so ReactMarkdown doesn't see a new plugins array on every render.
const REMARK_PLUGINS = [remarkGfm];
const REHYPE_PLUGINS = [rehypeHighlight];

export function MarkdownContent({ bodyMarkdown }) {
  return (
    <div
      className="prose prose-slate mt-10 max-w-none
        prose-headings:font-display prose-headings:tracking-tight
        prose-h1:text-[32px] prose-h2:text-[26px] prose-h3:text-[20px]
        prose-p:leading-relaxed prose-p:text-[16px] prose-p:text-slate-700
        prose-a:text-violet-700 prose-a:no-underline hover:prose-a:underline
        prose-strong:text-slate-900
        prose-code:before:content-none prose-code:after:content-none
        prose-code:bg-slate-100 prose-code:text-slate-900 prose-code:rounded prose-code:px-1.5 prose-code:py-0.5 prose-code:text-[13.5px] prose-code:font-normal
        prose-pre:bg-slate-950 prose-pre:text-slate-100 prose-pre:rounded-2xl prose-pre:p-5 prose-pre:text-[13.5px]
        prose-blockquote:border-l-violet-400 prose-blockquote:text-slate-700
        prose-img:rounded-2xl"
      data-testid="blog-content"
    >
      <ReactMarkdown remarkPlugins={REMARK_PLUGINS} rehypePlugins={REHYPE_PLUGINS}>
        {bodyMarkdown}
      </ReactMarkdown>
    </div>
  );
}
